<app-spinner [isLoading]="(isLoading$ | async)">
  @if ({
    selectedSpecializationsMap: selectedSpecializationsMap$ | async,
    specializationsTouched: specializationsTouched$ | async,
    atLeastOneSpecializationSelected: atLeastOneSpecializationSelected$ | async,
    selectedSpecializations: selectedSpecializations$ | async,
    formInitialValue: formInitialValue$ | async,
    jobseekerSubscriptionLookup: jobseekerSubscriptionLookup$ | async,
    jobseekerSubscriptionSpecializations: jobseekerSubscriptionSpecializations$ | async,
  }; as data) {
    <div class="subscribe-page">
      <h1 class="subscribe-page__title">{{ 'label.Subscription' | translate }}</h1>

      <div class="help-text" [innerHTML]="'text.SubscriptionInfo' | translate"></div>

      <form [formGroup]="subscriptionForm" #ngForm="ngForm" [appConnectForm]="data.formInitialValue"
        (ngSubmit)="onSubscribe(data.selectedSpecializations)">

        <h2 class="section-title">{{ 'label.Specialties' | translate }}</h2>
        @if ((data.specializationsTouched || ngForm.submitted) && !data.atLeastOneSpecializationSelected) {
          <mat-error class="validation-message">
            {{ 'message.SelectAtLeastOneSpecialty' | translate }}
          </mat-error>
        }

        <div class="specialties">
          @for (specialization of data.jobseekerSubscriptionSpecializations; track specialization.id) {
            <div class="specialties__item">
              <mat-checkbox (change)="onToggleSpecialization(specialization, $event)"
                [ngModel]="data.selectedSpecializationsMap[specialization.id]"
                [ngModelOptions]="{ standalone: true }">
                {{ specialization.name }}
              </mat-checkbox>
            </div>
          }
        </div>

        <p class="filters-description">{{ 'text.SelectLocalitiesInfo' | translate }}</p>
        <div class="filters">
          <div class="filters__item">
            <p-multiSelect
              ngSkipHydration
              [options]="data.jobseekerSubscriptionLookup?.locations"
              optionLabel="name"
              [placeholder]="'label.ChooseCity' | translate"
              [optionValue]="'id'"
              styleClass="dropdown-panel"
              [showToggleAll]="false"
              [panelStyleClass]="'dropdown-panel-style'"
              [appendTo]="'body'"
              formControlName="localities"
            >
              <ng-template let-item #item>
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>

              <ng-template pTemplate="selectedItems" let-selectedItems>
                @if (selectedItems?.length < maxSelectedValue) {
                  <div class="dropdown-selected-items">
                    @for (item of selectedItems; track item.id; let last = $last) {
                      <span>{{ last ? item.name : item.name + ', ' }}</span>
                    }
                  </div>
                }
                @if (selectedItems?.length >= maxSelectedValue) {
                  <span>{{ 'label.SelectedMultiselectOptions' | translate: { count: selectedItems.length } }}</span>
                }
              </ng-template>
            </p-multiSelect>
          </div>

          <div class="filters__item">
            <p-multiSelect
              ngSkipHydration
              [options]="data.jobseekerSubscriptionLookup?.seniorityLevels"
              optionLabel="name"
              [placeholder]="'label.SeniorityLevel' | translate"
              [optionValue]="'id'"
              styleClass="dropdown-panel"
              [showToggleAll]="false"
              [panelStyleClass]="'dropdown-panel-style'"
              [appendTo]="'body'"
              formControlName="seniorityLevels"
            >
              <ng-template let-item #item>
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>

              <ng-template pTemplate="selectedItems" let-selectedItems>
                @if (selectedItems?.length < maxSelectedValue) {
                  <div class="dropdown-selected-items">
                    @for (item of selectedItems; track item.id; let last = $last) {
                      <span>{{ last ? item.name : item.name + ', ' }}</span>
                    }
                  </div>
                }
                @if (selectedItems?.length >= maxSelectedValue) {
                  <span>{{ 'label.SelectedMultiselectOptions' | translate: { count: selectedItems.length } }}</span>
                }
              </ng-template>
            </p-multiSelect>
          </div>
        </div>

        <div class="actions">
          <button (click)="onCancelSubscribe()" class="actions__button actions__button--cancel" type="button">
            {{ 'label.Cancel' | translate }}
          </button>
          <button class="actions__button actions__button--save"
            [class.actions__button--dimmed]="!data.atLeastOneSpecializationSelected" type="submit">
            {{ 'label.Save' | translate }}
          </button>
        </div>
      </form>
    </div>
  }
</app-spinner>
